var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-encore-id": "icon",
    role: "img",
    "aria-hidden": "true",
    fill: "#ffffff",
    className: "Svg-sc-ytk21e-0 hPIlex sc-c630f568-2 dIjLwQ",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.793 15.957a1 1 0 0 0 1.414 0L12 8.164l7.793 7.793a1 1 0 1 0 1.414-1.414L12 5.336l-9.207 9.207a1 1 0 0 0 0 1.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretWhite);
export default __webpack_public_path__ + "static/media/caret_white.9febad063f3e5a9a7a7b60ea21838bdc.svg";
export { ForwardRef as ReactComponent };